__turbopack_context__.v({
  "CardEvanhub": "Areas-module__Duqfma__CardEvanhub",
  "GridCard": "Areas-module__Duqfma__GridCard",
  "InfoCard": "Areas-module__Duqfma__InfoCard",
});
